import { USER_LOGIN, USER_LOGOUT, APP_IFRAMED, SET_MAX_SCORE, SET_AFFILIATE } from "../actions";

import { loginUser, logoutUser } from "./user";
import { isIframed } from "../utils/gsntv";
import { REWARD_VIDEO_READY, REWARD_VIDEO_IRONSOURCE, REWARD_VIDEO_OPEN, REWARD_VIDEO_COMPLETION, REWARD_VIDEO_AD_BLOCKED, REWARD_VIDEO_SUPPORT, REWARD_VIDEO_STALE } from "../actions/rewardVideo";
import { rewardVideoReady, setIronRV, rewardVideoOpen, rewardVideoComplete, rewardVideoAdBlocked, setRewardVideoSupport, updateRewardVideoStale } from "./rewardVideo";

const initialState = {
  // userLoggedIn: true,
  userLoggedIn: false,
  user: null,
  isAppIframed: false,
  appInitiatedLogin: false,
  maxScore: null,
  affiliate: null,
  rewardVideo: {
    adBlocked: false,
    // noCampaign: false,
    ready: null,
    open: false,
    // close: false,
    complete: false,
    ironRV: null,
    support: false,
    stale: true
  }
};

function setAppIframed(state, action) {
  const isAppIframed = isIframed();

  return {
    ...state,
    isAppIframed
  };
}

function setMaxScore(state, action){
  console.log("Reducers :: setMaxScore - action = ", action);
  const maxScore = action.maxScore;
  return {
    ...state,
    maxScore
  }
}

function setAffiliate(state, action) {
  let affiliate = {};
  switch (action.data) {
    case 'fox4more':
      affiliate.imgName = 'fox4more-logo.png';
      affiliate.url = 'http://www.fox4news.com/kdfi-my27';
      break;
    case 'fox9plus':
      affiliate.imgName = 'fox9plus-logo.png';
      affiliate.url = 'http://www.fox9.com/plus';
      break;
    case 'fox10xtra':
      affiliate.imgName = 'fox10xtra-logo.png';
      affiliate.url = 'http://www.fox10phoenix.com/fox10xtra';
      break
    case 'foxmy13':
      affiliate.imgName = 'foxmy13-logo.png';
      affiliate.url = 'http://www.foxla.com/my13';
      break
    case 'foxmy56':
      affiliate.imgName = 'foxmy56-logo.png';
      affiliate.url = 'http://www.fox35orlando.com/my65';
      break
    case 'ktvuplus':
      affiliate.imgName = 'ktvuplus-logo.png';
      affiliate.url = 'http://www.ktvu.com/news/ktvuplus';
      break
    default:
      affiliate = null;
  }
  return {
    ...state,
    affiliate
  }
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN:
      return loginUser(state, action);
    case USER_LOGOUT:
      return logoutUser(state, action);
    case APP_IFRAMED:
      return setAppIframed(state, action);
    case SET_MAX_SCORE:
      return setMaxScore(state, action);
    case REWARD_VIDEO_READY:
      return rewardVideoReady(state, action);
    case REWARD_VIDEO_IRONSOURCE:
      return setIronRV(state, action);
    case REWARD_VIDEO_OPEN:
      return rewardVideoOpen(state, action);
    case REWARD_VIDEO_COMPLETION:
      return rewardVideoComplete(state, action);
    case REWARD_VIDEO_AD_BLOCKED:
      return rewardVideoAdBlocked(state, action);
    case REWARD_VIDEO_SUPPORT:
      return setRewardVideoSupport(state, action);
    case REWARD_VIDEO_STALE:
      return updateRewardVideoStale(state, action);
    case SET_AFFILIATE:
      return setAffiliate(state, action);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/js/reducers/index.js